export default __webpack_public_path__ + "static/media/Group-965.9eb473fb.svg";